import common from "./common";
import menu from "./menu";
import { smartStrategy } from "webpack-merge";
const state = {
  m_groupInfo: [],
  m_CheckInfo: {
    status: false,
    message: null
  },
  grade: null,
  countUser: null,
  coGroupInfo: {},
  siteMaxSize: null,
  siteUseSize: null,
  folderList: {},
  fileList: {},
  subFolderList: {},
  paperList: {},
  coGroupList: {},
  oneDepthCategory: {},
  twoDepthCategory: {},
  folderTreeList: {},
  coCategoryList: [],
  coGroupUser: [],
  coGroupListforUser: [],
  coGroupBoardThree: []
};
const actions = {
  /* 그룹 이름 중복 검사 */
  checkGroupName({ commit }, data) {
    // console.log(data);
    let message = "";
    let status = false;
    let groupName = data.groupName;
    let object = data.object;
    //공백확인
    let string = groupName.replace(/(\s*)/g, "");
    if (string == undefined || string == "" || string == null) {
      message = "";
    } else {
      if (groupName == undefined || groupName == "" || groupName == null) {
        message = "";
      } else {
        //axios 를 통해 REST-API 를 호출하여 결과값에 따라
        const param = {
          data: {
            url: "/api/cogroup/cogroup/checkCoGroupName",
            sendType: "post",
            obj: object,
            req: {
              groupName: groupName
              //   inoutKbn: "IN" //내부,외부 구분 수정필요
            }
          }
        };
        common.actions
          .ASYNC_COWORK_REST_ACTION({}, param)
          .then(response => {
            if (response.result === 1) {
              message = this.$t("message.cooperation.001", "이미 사용중입니다.");
              status = false;
            } else {
              message = this.$t("message.cooperation.002", "사용 가능");
              status = true;
            }
          })
          .then(() => {
            commit("setCheckMessage", { message, status });
          })
          .catch(error => {
            console.log("그룹명 중복체크 실패");
            console.log(error);
          });
      }
    }
  },
  /* 신규 그룹 생성 */
  createGroup({ commit }, data) {
    console.log(data.groupInfo);
    const groupInfo = data.groupInfo;
    const object = data.object;
    const param = {
      data: {
        url: "/api/cogroup/cogroup/registCoGroup",
        sendType: "post",
        obj: object,
        req: groupInfo
      }
    };
    /* 차후 axios 를 통해 REST-API 를 호출하여 그룹 생성 호출 */
    common.actions
      .ASYNC_COWORK_REST_ACTION({}, param)
      .then(() => {
        console.log("협업공간 생성 완료");
        alert(this.$t("message.cooperation.003", "협업공간 생성 완료"));
      })
      .then(() => {
        const params = {
          data: {
            url: "/api/cogroup/cogroup/getMyCoGroupList",
            sendType: "post",
            obj: object,
            req: {
              type: "2",
              groupKbn: "COLA"
            }
          }
        };

        common.actions
          .ASYNC_COWORK_REST_ACTION({}, params)
          .then(data => {
            console.log(data);
            menu.state.cooperationMenu = data.result.data;
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(error => {
        console.log("협업공간 생성 실패");
        console.log(error);
      });
  },
  /* 그룹 수정 */
  updateGroup({}, data) {
    const groupInfo = data.groupInfo;
    const object = data.object;
    const param = {
      data: {
        url: "/api/cogroup/cogroup/updateCoGroup",
        sendType: "post",
        obj: object,
        req: groupInfo
      }
    };

    /* 차후 axios 를 통해 REST-API 를 호출하여 그룹 생성 호출 */
    common.actions
      .ASYNC_COWORK_REST_ACTION({}, param)
      .then(() => {
        console.log("[협업공간 수정 완료]");
        alert(this.$t("message.cooperation.004", "협업공간수정완료"));
      })
      .catch(error => {
        console.log("[협업공간 수정 실패]");
        console.log(error);
      });
  },

  /* 그룹 삭제 */
  deleteGroup({}, data) {
    console.log(data);
    const group = data.groupId;
    const object = data.object;
    const param = {
      data: {
        url: "/api/cogroup/cogroup/deleteCogroup",
        sendType: "post",
        obj: object,
        req: {
          groupId: group
        }
      }
    };

    /* 차후 axios 를 통해 REST-API 를 호출하여 그룹 생성 호출 */
    common.actions
      .ASYNC_COWORK_REST_ACTION({}, param)
      .then(() => {
        console.log("[협업공간 삭제 완료]");
        alert(this.$t("message.cooperation.005", "협업공간 삭제 완료"));
      })
      .catch(error => {
        console.log("[협업공간 삭제 실패]");
        console.log(error);
      });
  },

  getGroupCategoryList({ commit }, data) {
    const param = {
      data: {
        url: "/api/copaper/category/getGroupCategoryList",
        sendType: "post",
        obj: data.object,
        req: {
          groupId: data.groupId
          // groupId : "45"
        }
      }
    };

    common.actions
      .ASYNC_COWORK_REST_ACTION({}, param)
      .then(function(res) {
        //			if(res.errorCode == null) {
        //obj.setCoCategoryList(res.result);
        commit("setCoCategoryList", res.result);
        //			}
      })
      .catch(function(err) {
        console.log(err);
      });
  },

  getLastUpdatedBoardThree({ commit }, data) {
    const param = {
      data: {
        url: "/api/copaper/paper/getRecentPaperList",
        sendType: "get",
        obj: data.object,
        req: {
          // groupId : data.groupId
          // groupId : "45"
        }
      }
    };

    common.actions
      .SYNC_COWORK_REST_ACTION({}, param)
      .then(function(res) {
        //				if(res.errorCode == null) {
        commit("setCoGroupBoardThree", res.result);
        //				}
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
const mutations = {
  /* 중복검사 return message setting */
  setCheckMessage(state, payload) {
    state.m_CheckInfo.message = payload.message;
    state.m_CheckInfo.status = payload.status;
  },
  /* 신규 협업공간 정보 setting */
  setGroupInfo(state, payload) {
    state.m_groupInfo.push(payload);
  },
  setCoGroupInfo(state, payload) {
    state.grade = payload.grade;
    state.coGroupInfo = payload.data;
    state.countUser = payload.countUser;
  },
  setCoGroupVolume(state, payload) {
    state.siteMaxSize = payload.siteMaxSize;
    state.siteUseSize = payload.siteUseSize;
  },
  setFolderList(state, payload) {
    state.folderList = payload.folderList;
  },
  setFileList(state, payload) {
    state.fileList = payload.fileList;
  },
  setSubFolderList(state, payload) {
    if (payload === null) {
      state.subFolderList = {};
    } else {
      state.subFolderList = payload.folderList;
    }
  },
  setPaperList(state, payload) {
    state.paperList = payload;
  },
  setCoGroupList(state, payload) {
    state.coGroupList = payload;
  },
  setCategoryOneDepth(state, payload) {
    state.oneDepthCategory = payload;
  },
  setCategoryTwoDepth(state, payload) {
    state.twoDepthCategory = payload;
  },
  setFolderTreeList(state, payload) {
    state.folderTreeList = payload.folderList;
  },
  setCoCategoryList(state, payload) {
    state.coCategoryList = payload;
  },
  setCoGroupUser(state, payload) {
    state.coGroupUser = payload;
  },
  setCoGroupListforUser(state, payload) {
    state.coGroupListforUser = payload;
  },
  setCoGroupBoardThree(state, payload) {
    state.coGroupBoardThree = payload;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/modules/cooperation.js